import { initI18n } from '@kk/ui/i18n';
import uiTranslations from '@kk/ui/locales/da/ui.json';

export function setupI18n() {
  return initI18n({
    lng: 'da',
    resources: {
      da: {
        ui: uiTranslations,
      },
    },
    defaultNS: 'ui',
    ns: ['ui'],
  });
}

export default setupI18n();
